import * as React from 'react';
import styles from './index.less';
import {
  Sider_OnChange_Page_Action,
  Sider_OnMount_Page_Action,
  Sider_OnUpdate_Data_Action,
} from '@/models/collectionManager';
import { Dispatch } from 'redux';
import * as AHooks from 'ahooks';
import { useParams } from 'umi';
import { connect } from 'dva';
import { ConnectState } from '@/models/connect';
import FMicroAPP_Authorization from '@/components/FMicroAPP_Authorization';
import {
  OnMount_Page_Action,
  OnUnmount_Page_Action,
  ResourceDependencyPageState,
} from '@/models/resourceDependencyPage';

interface DependencyProps {
  dispatch: Dispatch;
  resourceDependencyPage: ResourceDependencyPageState;
}

function Dependency({ dispatch, resourceDependencyPage }: DependencyProps) {
  const params = useParams<{ id: string }>();
  AHooks.useMount(async () => {
    dispatch<Sider_OnMount_Page_Action>({
      type: 'collectionManager/sider_onMount_Page',
      payload: {
        resourceID: params.id!,
      },
    });
    dispatch<Sider_OnChange_Page_Action>({
      type: 'collectionManager/sider_onChange_Page',
      payload: {
        page: 'dependency',
      },
    });
    dispatch<OnMount_Page_Action>({
      type: 'resourceDependencyPage/onMount_Page',
      payload: {
        resourceID: params.id!,
      },
    });
  });

  AHooks.useUnmount(() => {
    dispatch<OnUnmount_Page_Action>({
      type: 'resourceDependencyPage/onUnmount_Page',
    });
  });

  return (
    <>
      <div className={styles.root}>
        <div style={{ height: 40 }} />
        <div className={styles.block}>
          {resourceDependencyPage.reload > 0 && (
            <FMicroAPP_Authorization
              licenseeId={resourceDependencyPage.resourceID}
              mainAppType={'resourceDepAuth'}
              depList={resourceDependencyPage.directDependencies}
              upcastList={resourceDependencyPage.baseUpcastResources}
              // reload={resourceDependencyPage.reload}
              // applyVersions={[]}
              update={(value) => {
                dispatch<Sider_OnUpdate_Data_Action>({
                  type: 'collectionManager/sider_onUpdate_Data',
                  // payload: resourceAuthPage.resourceID,
                });
              }}
            />
          )}
        </div>
        <div style={{ height: 100 }} />
      </div>
    </>
  );
}

export default connect(({ resourceDependencyPage }: ConnectState) => ({
  resourceDependencyPage: resourceDependencyPage,
}))(Dependency);
